import React from "react"

export const Footer = () => {
  return (
    <>
      <footer>
        <p>Curated by the Aryans</p>
      </footer>
    </>
  )
}
